import { IDB_notifications } from '../IDB/IDB.dexie'
import { DS_setData } from '../DS/DS.Data'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'

export async function Noti_initialise() {
    const unreadNotifications = new Set<UUID>()

    // Find all the unread notifications in IDB
    await IDB_notifications().each((notification) => {
        if (notification.readAt === null) unreadNotifications.add(notification.id)
    })

    // Add them to the in-memory data store
    DS_setData('NotificationsInitialize', () => ({ unreadNotifications: [...unreadNotifications] }))
}
